module.exports = __webpack_public_path__ + "static/img/beauty_regimen.bf56a45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/collage/papercuts/beauty_regimen.jpg
// module id = q/+o
// module chunks = 1